<template>
    <div>
        <section class="page-title" style="background-color:#c7eafb;">
            <div class="center">
                <v-layout row wrap>
                    <v-flex xs12 sm12 lg8>
                        <p class="label-planos">Convênio Plano Odontológico</p>
                        <h1 class="the-title">Parceria</h1>   
                        <h1 class="the-title" style="font-size:30px;color:#00358d">SINDICATO DOS HOTÉIS RESTAURANTES BARES E SIMILARES BAIXADA SUL FLUMINENSE</h1>
                    </v-flex>
                    <v-flex xs12 sm12 lg4 style="text-align: right;" v-if="this.$vuetify.breakpoint.lg">  
                        <img src="../Content/images/logoSindhoteis.jpg" width="300">
                    </v-flex>
                    <v-flex xs12 sm12 lg4 style="text-align: center;" v-else>  
                        <img src="../Content/images/logoSindhoteis.jpg" width="180">
                    </v-flex>  
                    <v-flex xs12 sm6 md6 lg6>
                        <v-btn style="border-radius: 6px;" large dark @click="openDialog()" color="#00358d">Faça já a sua adesão</v-btn>
                    </v-flex>
                </v-layout>
            </div>
        </section>

        <section class="page-content center">
            <v-layout row wrap>
                <v-flex xs12 sm12 lg10>
                    <img v-if="this.$vuetify.breakpoint.lg" src="../Content/images/valorSindhoteis.png" style="position: absolute;left: 90%;" width="150px">
                    <img v-else src="../Content/images/valorSindhoteis.png" width="150px">

                    <p class="title-label">O seu sorriso é o nosso diferencial</p>
                    <p>Informamos que, em Setembro de 2021, o Sindicato dos Hotéis Restaurantes Bares e Similares Baixada Sul Fluminense fechou uma parceria com a PrimaVida Dental e está disponibilizando para todos os empresários e trabalhadores das empresas vinculadas ao sindicato, Plano Odontológico de qualidade, com um custo acessível e tratamento eficaz.</p>

                    <p><strong>Sobre a PrimaVida Dental</strong></p>
                    <p>A PrimaVida Dental é uma operadora exclusivamente odontológica, com 15 anos de mercado, com aproximadamente 260.000 beneficiários, mais de 7.000 prestadores em todo Brasil, devidamente registrada na Agência Nacional de Saúde Suplementar (ANS) sob o nº 416525, possui processos de gestão inovadores, com tecnologia de ponta e modernidade, garantindo assim agilidade, segurança e a tranquilidade para os seus associados.</p>

                    <p><strong>Benefícios</strong></p>
                    <p>O Plano disponibilizado para a entidade de classe possui cobertura para todo o Rol de Procedimentos da ANS – Agência Nacional de Saúde Suplementar, com utilização imediata dos serviços, por não possuir carência contratual.</p>
                    <p>Além de ampla rede credenciada com inúmeras opções de atendimento e especialidades, com destaque para os dentistas do Rio de Janeiro.</p>
                    <p>Com o mais alto nível de informatização, permite também por aplicativo, onde na palma da mão, através de Smartphone ou Tablet, acesso a carteirinha virtual, rede credenciada, atendimento personalizado tudo para uma fácil utilização, com um sistema diferenciado de atendimento via WhatsApp, de forma a proporcionar conforto, com a certeza de bom atendimento e qualidade, tudo com muita transparência e respeito.</p>

                    <p>O custo do plano odontológico será 100% (cem por cento), pago pelo trabalhador, e caso queira, o trabalhador poderá incluir seus dependentes, pagando o valor, em condições especiais, através de desconto em folha de pagamento. Os Valores do plano contratado serão:</p>
                    <p><strong>- Funcionário: R$ 18,00, com o valor integral descontado em folha.</strong></p>
                    <p><strong>- Dependente: R$ 18,00, com o valor integral descontado em folha.</strong></p>
                </v-flex>
                <v-flex xs12 sm12 lg12>
                    <br>
                    <p class="title-label">Aproveite já a oportunidade e garanta o sorriso dos seus colaboradores com a PrimaVida Dental.</p>
                    <br>
                </v-flex>
                <v-flex xs12 sm12 lg12>
                    <img src="../Content/images/logo.png" width="200">
                </v-flex>
                <v-flex xs12 sm12 lg7>
                    <br>
                    <p class="title-label">Acesso à rede credenciada</p>
                    <p>Para acessar a rede credenciada, <a href="http://www.primavida.com.br/redecredenciada" target="_blank">clique aqui.</a></p>
                </v-flex>
                <v-flex xs12 sm12 lg6>
                    <p class="title-label">Quem pode aderir ao Plano?</p>
                    <ul>Titular: Funcionários da empresa;</ul>
                    <ul>Cônjuge ou companheiro;</ul>
                    <ul>Dependentes:</ul>
                    <li>Filhos solteiros até 18 anos;</li>
                    <li>Filhas solteiras até 21 anos.</li>
                    <br>
                </v-flex>
                <v-flex xs12 sm12 lg6>
                    <p class="title-label">Principais Vantagens</p>
                    <li>Liberação on-line do seu plano de tratamento;</li>
                    <li>O Beneficiário pode incluir familiares e agregados;</li>
                    <li>Acesso a rede credenciada através do site www.primavida.com.br;</li>
                    <li>Desconto em medicamentos nas farmácias &nbsp;<img src="../Content/images/raia.jpg" width="60px"> &nbsp; <img src="../Content/images/drogasil.jpg" width="110px"></li>
                    <li>Central de Atendimento exclusiva por Whatsapp;</li>
                    <li>Aplicativo para Celular / Tablet com rede Credenciada;</li>
                    <li>Carteirinha Virtual;</li>
                    <li>Boleto Virtual;</li>
                    <br>
                </v-flex>
                <v-flex xs12 sm12 lg12>
                    <br>
                    <p class="title-label" style="color:#212121;">App PrimaVida Beneficiário</p>    
                </v-flex>
                <v-flex xs5 sm5 lg2>
                    <img src="../Content/images/app_android.png" width="120px"><br>
                    <a href="https://play.google.com/store/apps/details?id=br.com.primavida.associado" target="_blank"><img src="../Content/images/android.png" width="120px"></a>&nbsp;
                </v-flex>
                <v-flex xs5 sm5 lg2>
                    <img src="../Content/images/app_apple.png" width="120px"><br>
                    <a href="https://apps.apple.com/br/app/primavida-dental-associado/id1464690839" target="_blank"><img src="../Content/images/apple_stote.png" width="120px" ></a>&nbsp;
                </v-flex>
                <v-flex xs5 sm5 lg2>
                    <img src="../Content/images/app_whats.png" width="120px"><br>
                    <a href="https://api.whatsapp.com/send?phone=5521971640379" target="_blank"><img src="../Content/images/whatsapp.png" width="120px" ></a>&nbsp;
                </v-flex>
                <v-flex xs5 sm5 lg3>
                    <img src="../Content/images/celular.png" width="130px"><br>    
                </v-flex>
                <v-flex xs5 sm5 lg12>
                    <table cellpadding="0" cellspacing="0" border="1">
                        <tr>
                            <td style="color: #009b9b;">Plano: </td> 
                            <td>&nbsp; SMILE 1000 RJ </td>
                        </tr>
                        <tr>
                            <td style="color: #009b9b;">Reg ANS nº: </td>
                            <td>&nbsp; 475.689/08-6 </td>
                        </tr>
                        <tr>
                            <td style="color: #009b9b;">Tipo de Contratação: </td>
                            <td>&nbsp; COLETIVO EMPRESARIAL </td>
                        </tr>
                        <tr>
                            <td style="color: #009b9b;">Formação de Preço: </td>
                            <td>&nbsp; PRÉ-ESTABELECIDO </td>
                        </tr>
                        <tr>
                            <td style="color: #009b9b;">Área de Abrangênia/Atuação: </td>
                            <td>&nbsp; GRUPO DE MUNICIPIOS RJ </td>
                        </tr>
                        <tr>
                            <td style="color: #009b9b;">Segmetação Assistencial: </td>
                            <td>&nbsp; EXCLUSIVAMENTE ODONTOLÓGICA </td>
                        </tr>
                        <tr>
                            <td style="color: #009b9b;">Carência: </td>
                            <td>&nbsp; SEM CARÊNCIA </td>
                        </tr>
                    </table>
                </v-flex>
            </v-layout>
            <br>
            <p class="title-label">Principais Coberturas (Rol da ANS)</p>
            <div class="icone consultas">
                <span class="icon"></span>
                <p><strong>Consultas</strong> - Consultas iniciais para o plano de tratamento;</p>
            </div>
            <div class="icone urgencia">
                <span class="icon"></span>
                <p><strong>Urgência</strong> - Diversos procedimentos de urgência odontológica;</p>
            </div>
            <div class="icone cirurgia">
                <span class="icon"></span>
                <p><strong>Cirurgia</strong> - Cirurgias odontológicas de pequeno porte realizada em consultórios;</p>
            </div>
            <div class="icone dentistica">
                <span class="icon"></span>
                <p><strong>Dentística</strong> - Restaurações e obturações em material estético (Resina) e amálgama;</p>
            </div>
            <div class="icone endodontia">
                <span class="icon"></span>
                <p><strong>Endodontia</strong> - Tratamento de canais;</p>
            </div>
            <div class="icone periodontia">
                <span class="icon"></span>
                <p><strong>Periodontia</strong> - Tratamento de gengivas;</p>
            </div>
            <div class="icone odontopediatria">
                <span class="icon"></span>
                <p><strong>Odontopediatria</strong> - Atendimento especializado para crianças;</p>
            </div>
            <div class="icone radiologia">
                <span class="icon"></span>
                <p><strong>Raio X</strong> - Periapical, interproximal (bite-wing), oclusal, periapical completa (levantamento radiográfico) e panorâmica;</p>
            </div>
            <div class="icone protese">
                <span class="icon"></span>
                <p><strong>Próteses</strong> - Coroa provisória, Restauração, Coroa, Núcleo e Bloco metálico para dentes permanentes posteriores, Coroa em Cerômero para dentes permanentes anteriores (Entende-se como dentes permanentes anteriores, os dentes definitivos da frente, que correspondem do canino a canino);</p>
            </div>
            <div class="icone profilaxia">
                <span class="icon"></span>
                <p><strong>Prevenção</strong> - Profilaxia / Aplicação de Flúor;</p>
            </div>
            <div class="icone exodontia">
                <span class="icon"></span>
                <p><strong>Exodontia</strong> - Extração, inclusive de siso incluso;</p>
            </div>
            <div>
                <p>Para acessar a cobertura do Rol da ANS, <a href="http://www.primavida.com.br/emkt/rol_procedimentos.pdf" target="_blank">clique aqui.</a></p>
                <p>A adesão é feita de forma bem simples e totalmente digital. Basta clicar no botão abaixo, preencher todos os dados e anexar os documentos necessários. Em até 72 horas úteis, receberá no e-mail cadastrado, login e senha de primeiro acesso personalizado.</p>
                <p>Ficha de Adesão, <a href="https://ecommerce.primavida.com.br/contratos/FICHA_DE_ADESAO_COLETIVO_POR_ADESAO_F.A.0321.pdf" target="_blank">clique aqui.</a></p>
            </div>
            <v-flex xs12 sm6 md6 lg12>
                <v-btn style="border-radius: 6px;" large dark @click="openDialog()" color="#00358d">Faça agora a adesão</v-btn>
                <img src="../Content/images/logo-ans.png" width="200" style="float:right;">
            </v-flex>
        </section>
        <v-dialog v-model="dialog" max-width="700px" max-height="400px"> 
            <v-card>
                <v-container grid-list-md>
                    <v-layout row wrap justify-center>
                        <v-card-title>
                            <span class="total">Prezado(a) parceiro(a),</span>
                        </v-card-title>
                        <v-container fluid pa-1 justify-center class="resumo">
                            <p class="resumo" >Valorizamos a privacidade de seus dados. Por isso, investimos em modernidade nos nossos canais de comunicação, garantindo assim a  segurança e a tranquilidade que você precisa.</p>
                            <p class="resumo" >Por esse motivo, estamos enviando um termo de privacidade sobre os seus dados cadastrais.</p>
                            <p class="resumo" >É necessário que você acesse nossa política de privacidade e aceite os termos para continuarmos recebendo e enviando suas informações.</p>
                            <br>
                            <p class="resumo" style="font-weight: bold">A <span style="color:#009B99">PrimaVida Dental</span> agradece a sua atenção !</p>
                            <p class="resumo" style="font-weight: bold">Vindo de você, tudo é importante!!!</p>
                            <br>
                            <p class="resumo" style="font-weight: bold;color:#009B99">Termo de Privacidade, <a href="https://ecommerce.primavida.com.br/contratos/Politica_de_Privacidade_PrimaVida_LGPD.pdf" target="_blank">clique aqui.</a></p>
                            <v-checkbox v-model="contrataccept" color="#009B99">
                                <span slot="label">Estou ciente e concordo com o Termo de Privacidade da PrimaVida Dental.</span>
                            </v-checkbox>
                        </v-container>
                    </v-layout>
                    <v-card-actions>
                        <v-container fill-height fluid pa-1 justify-center>
                            <br>
                            <v-btn :disabled="!contrataccept" color="#009b9b" depressed style="border-radius: 8px; width: 130px;color: white;" :href="'https://ecommerce.primavida.com.br/contratopj?plano=61ae614610d111043d351802'">Continuar</v-btn>
                        </v-container>
                    </v-card-actions>
                </v-container>
            </v-card>
        </v-dialog>
        <Snackbar ref=chamaSnackbar />
    </div>
</template>
<script>
import Snackbar from '../components/snackbar.vue'
export default {
    components: {Snackbar},
     data(){
        return{   
                contrataccept: false,
                dialog: false,
                matricula: '',
                dictionary: {          
                custom: {               
                carteirinha: {
                  required: () => 'Informe o número da carteirinha'
                } 
                }
                }
        }               
    },

    mounted : function(){
        this.$store.dispatch('EscondeToolbar')
        this.$store.dispatch('EscondeFooter')
        this.$validator.localize('pt', this.dictionary)
        localStorage.clear()
        sessionStorage.clear()

    },
     watch: {
        dialog(val) {
        val || this.close()
      }
     },
    methods: {
        openDialog(){
            this.dialog = true
        }
        
    }

}
</script>

<style>

    .link{
        font-size: 1.3rem;
        color: #194383;
        text-align: center;
    }
    .titulo{
        font-size: 2rem;
        color: #797a7a;
        text-align: center;
    }
    .tabela{
        border-collapse: separate;
        border-spacing: 2;
    }
</style>